export default () => ({
    shouldScroll: false,

    init() {
        this.onResize()

        window.addEventListener('resize', this.onResize.bind(this))
    },

    onResize() {
        const containerWidth = this.$root.offsetWidth
        const contentWidth = this.$refs.content.offsetWidth

        this.shouldScroll = contentWidth > containerWidth
    },
})
